import { useEffect } from 'react'
import { useAuth } from '../contexts/Auth'
import { getLoggedUserInfos } from '../helpers/AuthHelper'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { LoadingFullScreen } from './LoadingFullScreen'
import AppHypertuneProvider from '../components/HypertuneProvider'

export const LayoutLogged: React.FC = () => {
  const { pathname } = useLocation()
  const { isLogged, currentUser, updateCurrentUser } = useAuth()

  useEffect(() => {
    if (isLogged !== true) return
    getLoggedUserInfos().then((result) => {
      updateCurrentUser(result.data.data)
    })
  }, [isLogged])

  if (isLogged === false) {
    // We're not checking !isLogged as isLogged might be undefined during the account fetching on init
    // Ensure redirection to home page if the user is logged
    return <Navigate to={'/auth/login?returnTo=' + pathname} />
  }

  if (currentUser === undefined) {
    return <LoadingFullScreen />
  }

  return (
    <AppHypertuneProvider>
      <Outlet />
    </AppHypertuneProvider>
  )
}
